package com.evoapps.evoshift.util

import kotlinx.browser.window

actual fun platformTextSharer(): TextSharer = TextSharer { text, subject ->
    val navigator = window.navigator.asDynamic()
    if (navigator.share == undefined) return@TextSharer false
    val data = js("({})")
    data.title = subject
    data.text = text
    // The person may cancel the sheet: nothing to report.
    navigator.share(data).catch { _: dynamic -> Unit }
    true
}
